import styled from "styled-components";

export const ContainerBeneficios = styled.div`
    width: 100%;
    height: 100vh;
    display: flex;
    align-items: center;
    flex-direction: column;
    h1 {
        display: flex;
        align-items: flex-start;
        width: 80%;
        font-family: Rubik; 
        font-style: normal;
        font-size: 24px;
        span {
            font-weight: 400;
            padding-left: 20px;
        }
    }
    
`;

export const TableContainer = styled.div`
    width: 900px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    padding-top: 10px;
    .cargando {
        width: 100%;
        height: 600px;
    }
`;